/**
 * Base API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { FormatConfigEntry } from '../model/formatConfigEntry';
// @ts-ignore
import { FormatConfigResponse } from '../model/formatConfigResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class BaseformatService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param kanton 
     * @param type 
     * @param path 
     * @param componentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FormatConfigEntry>;
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FormatConfigEntry>>;
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FormatConfigEntry>>;
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (kanton === null || kanton === undefined) {
            throw new Error('Required parameter kanton was null or undefined when calling getFormat.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getFormat.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (path !== undefined && path !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>path, 'path');
        }
        if (componentId !== undefined && componentId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>componentId, 'componentId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/base/format/${this.configuration.encodeParam({name: "kanton", value: kanton, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "type", value: type, in: "path", style: "simple", explode: false, dataType: "'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM'", dataFormat: undefined})}`;
        return this.httpClient.request<FormatConfigEntry>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param kanton 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFormatConfig(kanton: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FormatConfigResponse>;
    public getFormatConfig(kanton: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FormatConfigResponse>>;
    public getFormatConfig(kanton: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FormatConfigResponse>>;
    public getFormatConfig(kanton: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (kanton === null || kanton === undefined) {
            throw new Error('Required parameter kanton was null or undefined when calling getFormatConfig.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/base/format/all/${this.configuration.encodeParam({name: "kanton", value: kanton, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<FormatConfigResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
